import { Theme } from "@mui/material/styles";

const styles = (theme: Theme) =>
  ({
    "&.MuiButton-containedPrimary": {
      background: "#60c5db",
      border: 'none',
      borderRadius: '2px',
      boxShadow: 'none',
      padding: '12px 40px',
      textTransform: 'initial',
      fontSize: 16,
      letterSpacing: '0.5px',
      '& span': {
        fontFamily: "'Playfair Display', serif",
      },
    },
    "&.text": {
      textTransform: 'none',
      fontSize: 15,
      padding: 0,
      color: '#000',
      textDecoration: 'underline',
      fontFamily: '"Barlow", sans-serif',
      '&:hover, &:focus, &:active, &:visited': {
        background: 'transparent',
      },
    },
  } as any);

export default styles;
